import React from "react";

const GroupVisibilityToggle = ({ groupVisibility, setAllGroupsVisibility }) => {
  const someGroupsVisible = Object.values(groupVisibility).some(
    (visible) => visible
  );

  return (
    <button
      className={`px-4 py-2 text-white rounded shadow text-nowrap ${
        someGroupsVisible ? "bg-gray-300" : "bg-blue-500"
      }`}
      onClick={() => setAllGroupsVisibility(!someGroupsVisible)}
    >
      {someGroupsVisible ? "Hide All" : "Show All"}
    </button>
  );
};

export default GroupVisibilityToggle;
